import React, {useState} from 'react';
import "../../assets/css/Dentobook.css";
import {Button} from "antd";
import {FormattedMessage} from "react-intl";
import PatientFinancesOperations from "./PatientFinancesOperations";
import {Patient} from "../../api-client";
import PatientFinancesInvoices from "./PatientFinancesInvoices";
import PatientFinancesProformaInvoices from "./PatientFinancesProformaInvoices";

interface PatientFinancesProps {
    patient: Patient;
}

const PatientFinancesTabs = ({patient}: PatientFinancesProps) => {
    const [selectedTab, setSelectedTab] = useState<'operations' | 'invoices' | 'proforma'>('operations');

    return (
        <>
            <div className="mt-24 mb-32" style={{display: 'flex', flexDirection: 'row', overflowX: 'scroll', borderBottom: 'solid 1px #B8B8B8'}}>
                <Button className="tabs-start-btn"
                        onClick={() => setSelectedTab('operations')}
                        type={selectedTab === 'operations' ? 'primary' : 'default'}><FormattedMessage
                    id="done_operations"/></Button>
                <Button className="tabs-middle-btn"
                        onClick={() => setSelectedTab('invoices')}
                        type={selectedTab === 'invoices' ? 'primary' : 'default'}><FormattedMessage
                    id="invoices"/></Button>
                <Button className="tabs-end-btn"
                        onClick={() => setSelectedTab('proforma')}
                        type={selectedTab === 'proforma' ? 'primary' : 'default'}><FormattedMessage
                    id="proforma_invoices"/></Button>
            </div>
            {selectedTab === 'operations' ? <PatientFinancesOperations patient={patient}/> : null}
            {selectedTab === 'invoices' ? <PatientFinancesInvoices patient={patient}/> : null}
            {selectedTab === 'proforma' ? <PatientFinancesProformaInvoices patient={patient}/> : null}
        </>
    );
};

export default PatientFinancesTabs;